"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const basic_form_input_1 = __importDefault(require("../../../client/form_components/inputs/basic_form_input"));
const custom_1 = __importDefault(require("../../../client/form_components/checkboxes/custom"));
const datetime_local_1 = __importDefault(require("../../../client/form_components/inputs/datetime/datetime_local"));
const form_select_1 = __importDefault(require("../../../client/form_components/selects/form_select"));
const datetimeInputHelpers_1 = require("../../../client/form_components/inputs/datetime/datetimeInputHelpers");
const Form_1 = require("./Form");
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const OPTIONAL_FIELDS = ['sponsor_ids', 'teaser', 'ready'];
const Settings = ({ errors, form, giveaway, handleUpdate, isSubmitting, options, inItOptions, pendingChanges, }) => {
    const startDate = form.start_date ?? giveaway.start_date;
    const endDate = form.end_date ?? giveaway.end_date;
    const fields = {
        ...giveaway,
        start_date: startDate,
        end_date: endDate,
    };
    const missingFields = [];
    Object.entries(fields).forEach(([key, value]) => {
        // skip optional fields
        if (OPTIONAL_FIELDS.includes(key))
            return;
        if (!value || value.length === 0) {
            missingFields.push(key);
            return;
        }
        // arrays are objects in js, we check for empty arrays above
        if (typeof value === 'object' && !Array.isArray(value)) {
            // check for nested id
            if (!value?.id) {
                missingFields.push(key);
                return;
            }
        }
    });
    const readyToLaunch = giveaway.ready || missingFields.length === 0;
    return (react_1.default.createElement("div", { className: Form_1.c.container },
        react_1.default.createElement("p", { className: Form_1.c.subHeader }, "Settings"),
        react_1.default.createElement("div", { className: Form_1.c.form },
            react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting, errors: errors?.slug, helperText: "This is the trailing portion of the url", label: "URL Path", name: "slug", onChange: ({ target: { value } }) => handleUpdate({ name: 'slug', value }), placeholder: "Epic-AI-Giveaway-2025", value: pendingChanges.has('slug') ? form.slug : giveaway.slug }),
            react_1.default.createElement(datetime_local_1.default, { autoComplete: "off", errors: errors?.start_date, helperText: "Times are in PT (-8 | -7 from UTC)", initValue: startDate ? (0, datetimeInputHelpers_1.formatPDTDate)(startDate) : null, label: "Start Date", name: "start_date", onChange: (value) => handleUpdate({ name: 'start_date', value }) }),
            react_1.default.createElement(datetime_local_1.default, { autoComplete: "off", errors: errors?.end_date, helperText: "Times are in PT (-8 | -7 from UTC)", initValue: endDate ? (0, datetimeInputHelpers_1.formatPDTDate)(endDate) : null, label: "End Date", name: "end_date", onChange: (value) => handleUpdate({ name: 'end_date', value }) }),
            react_1.default.createElement(form_select_1.default, { key: `${inItOptions.length}`, helperText: "Order matters, first listed will appear first on Giveaway Card / Page", label: "Sponsors (optional)", onSelectedChange: (opt) => handleUpdate({
                    name: 'sponsor_ids',
                    value: opt.map(({ value }) => value),
                }), options: options, placeholder: "Select platforms", type: "multi", value: pendingChanges.has('sponsor_ids') ? form.sponsor_ids : inItOptions }),
            react_1.default.createElement(custom_1.default, { classList: { help: typography_css_1.default.error }, disabled: !readyToLaunch, error: !readyToLaunch, helperText: !readyToLaunch
                    ? 'Please fill out all required fields before marking as ready.'
                    : '', isChecked: Boolean(pendingChanges.has('ready') ? form.ready : giveaway.ready), label: "Ready for launch!", name: "ready", onChange: (checked) => handleUpdate({ name: 'ready', value: checked }) }))));
};
exports.default = Settings;
